import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Moon, Sun, LogOut, BadgeCheck, User } from 'lucide-react';
import { useTheme } from '../../Context/ThemeContext';
import { useRole } from '../../Context/RoleContext';
import { useChatContext } from '../../Context/ChatContext';
import { AuthApi } from '../../Api/BaseApi';
import ProfileModal from '../ProfileModal';
import NotificationBell from '../NotificationBell';
import "./index.css";

const Navbar = () => {
    const { isDarkMode, toggleTheme } = useTheme();
    const { isAdmin } = useRole();
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, handleLogout: contextHandleLogout, handleLogoutAll } = useChatContext();

    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [userDetails, setUserDetails] = useState(null);

    
    const handleLogout = () => {
        contextHandleLogout();
    };

    const openProfile = async () => {
        try {
            const data = await AuthApi.getUserPermissions();
            setUserDetails(data);
            setIsProfileOpen(true);
        } catch (e) {
            console.error('Failed to load user details:', e);
        }
    };

    const closeProfile = () => {
        setIsProfileOpen(false);
    };

    const handleAdminPanel = () => {
        navigate('/admin');
    };

    const renderLogoContainer = () => {
        return (
            <div className="logo-container">
                <img src="/assets/logo.png" alt="Pinaka AI Logo" className="logo-img" />
            </div>
        );
    };
    

    const renderNotifications = () => <NotificationBell />;

    const renderThemeToggle = () => {
        return (
            <li className="action-item">
                <button
                    className="action-button theme-toggle"
                    onClick={toggleTheme}
                    aria-label="Toggle theme"
                >
                    {isDarkMode ?
                        <Sun size={18} className="light-icon" /> :
                        <Moon size={18} className="dark-icon" />
                    }
                </button>
            </li>
        )
    }

    const renderAdminButton = () => {
        const isActive = location.pathname.startsWith('/admin');
        return (
            <li className="action-item">
                <button
                    className={`action-button admin-button${isActive ? ' active' : ''}`}
                    onClick={handleAdminPanel}
                    aria-label="Admin Panel"
                    aria-current={isActive ? 'page' : undefined}
                >
                    <BadgeCheck size={18} />
                    <span className="admin-text sm-hide">Admin</span>
                </button>
            </li>
        )
    }

    const renderLogoutButton = () => {
        return (
            <li className="action-item logout-btn">
                <button
                    className="logout-button"
                    onClick={handleLogout}
                    aria-label="Logout"
                >
                    <span className="logout-text sm-hide">Logout</span>
                    <LogOut size={18} className="logout-icon" />
                </button>
            </li>
        )
    }

    const renderProfileButton = () => {
        return (
            <li className="action-item">
                <button
                    className="action-button"
                    onClick={openProfile}
                    aria-label="Profile"
                >
                    <User size={18} />
                    {/* <span className="sm-hide" style={{ marginLeft: 6 }}>Profile</span> */}
                </button>
            </li>
        )
    }

    return (
        <nav className="navbar">
            {!isAuthenticated && renderLogoContainer()}
            <ul className="navbar-actions">
                {isAuthenticated && (
                    <>
                        {renderNotifications()}
                        {renderThemeToggle()}
                        {renderProfileButton()}
                        {isAdmin() && renderAdminButton()}
                        {/* small vertical line */}
                        <span className="nav-divider" />
                        {renderLogoutButton()}
                    </>
                )}

                {!isAuthenticated && (
                    <>
                        {renderThemeToggle()}
                    </>
                )}

                {/* <li className="action-item user-profile">
                    <button className="profile-button">
                        <div className="avatar-container">
                            <User size={18} />
                        </div>
                            </button>
                </li> */}

            </ul>
            <ProfileModal
                isOpen={isProfileOpen}
                onClose={closeProfile}
                user={userDetails}
                onProfileUpdated={(updated) => setUserDetails((prev) => ({ ...prev, ...updated }))}
                onLogout={handleLogout}
                onLogoutAll={handleLogoutAll}
            />
        </nav>
    );
};

export default Navbar;